export const abortAtom = {
  id: 'uicore:abort',
  name: '终止事件流程',
  category: '逻辑',
  paramsSchema: {
    type: 'object',
    fields: []
  },
  execute: ctx => {
    ctx.abort();
  }
};
//# sourceMappingURL=abortAtom.js.map
